console.log("asides");

/**
 * Encapsule dans une <section class="cke-paragraphmanager emphasis emphasis--sm emphasis--skin-a">
 * tous les nœuds situés entre des <section> à l'intérieur de .rich-content,
 * dès lors qu'ils contiennent du contenu significatif (non vide).
 */
(function wrapOrphanNodes() {
  const WRAPPER_TAG = "section";
  const WRAPPER_ATTRS = {
    class: "cke-paragraphmanager emphasis emphasis--sm emphasis--skin-a",
    "data-title": "Encadré fond blanc avec liséré",
  };

  /** Crée une <section> avec les attributs cibles */
  function createWrapper(doc) {
    const section = doc.createElement(WRAPPER_TAG);
    for (const [attr, value] of Object.entries(WRAPPER_ATTRS)) {
      section.setAttribute(attr, value);
    }
    return section;
  }

  /**
   * Indique si un nœud est "significatif" (pas juste du whitespace / &nbsp;).
   * On ignore les <br> isolés et les nœuds texte vides.
   */
  function isSignificant(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent.replace(/[\u00a0\s]+/g, "").length > 0;
    }
    if (node.nodeType === Node.ELEMENT_NODE) {
      if (node.tagName === "BR") return false;
      // Récursion : le nœud est significatif s'il contient du contenu non vide
      return node.textContent.replace(/[\u00a0\s]+/g, "").length > 0;
    }
    return false;
  }

  /**
   * Traite un conteneur .rich-content :
   * regroupe les nœuds orphelins consécutifs dans une <section> wrapper.
   */
  function processContainer(container) {
    const children = Array.from(container.childNodes);
    const fragment = document.createDocumentFragment();

    let orphanBuffer = []; // nœuds orphelins accumulés

    function flushBuffer() {
      if (orphanBuffer.length === 0) return;

      // Ne créer le wrapper que si au moins un nœud est significatif
      const hasContent = orphanBuffer.some(isSignificant);
      if (hasContent) {
        const wrapper = createWrapper(document);
        const contentDiv = document.createElement("div");
        contentDiv.className = "emphasis__content";
        const innerDiv = document.createElement("div");
        for (const node of orphanBuffer) {
          innerDiv.appendChild(node.cloneNode(true));
        }
        contentDiv.appendChild(innerDiv);
        wrapper.appendChild(contentDiv);
        fragment.appendChild(wrapper);
      }
      orphanBuffer = [];
    }

    for (const child of children) {
      const isSection =
        child.nodeType === Node.ELEMENT_NODE &&
        child.tagName === "SECTION";

      if (isSection) {
        flushBuffer();               // vider le buffer avant la section
        fragment.appendChild(child.cloneNode(true));
      } else {
        orphanBuffer.push(child);    // accumuler le nœud orphelin
      }
    }

    flushBuffer(); // traiter les orphelins après la dernière section

    // Remplacer le contenu du conteneur d'un seul coup (performance)
    container.innerHTML = "";
    container.appendChild(fragment);
  }

  // Point d'entrée : uniquement les .rich-content enfants directs de .encadre,
  // lui-même enfant direct d'un <aside>
  const containers = document.querySelectorAll(
    "aside > .encadre > .rich-content"
  );
  if (containers.length === 0) return;

  for (const container of containers) {
    processContainer(container);
  }
})();
